import { Box } from '@mui/material';
import React from 'react';
import { StyledTypography } from '../../styles/styles';
import ChatNotificationChannelIcon, {
  ChatNotificationChannel,
} from './ChatNotificationChannelIcon';

interface ChatNotificationChannelLabelProps {
  channel: ChatNotificationChannel;
  label: string;
  connectedDetail?: string | null;
}

/** Icon + product name — brand marks are always paired with an accurate text label. */
const ChatNotificationChannelLabel: React.FC<ChatNotificationChannelLabelProps> = ({
  channel,
  label,
  connectedDetail,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25, minWidth: 0 }}>
    <Box sx={{ mt: connectedDetail ? 0.125 : 0 }}>
      <ChatNotificationChannelIcon channel={channel} />
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <StyledTypography sx={{ fontWeight: 600 }}>{label}</StyledTypography>
      {connectedDetail && (
        <StyledTypography sx={{ fontSize: '0.8rem' }} tone="tone1">
          {connectedDetail}
        </StyledTypography>
      )}
    </Box>
  </Box>
);

export default ChatNotificationChannelLabel;
